import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  description: string;
  flip?: boolean;
  id: string;
  title: string;
  tone: "white" | "slate";
};

export default function MarketingSplitSection({ children, description, flip = false, id, title, tone }: Props) {
  return (
    <section id={id} className={`py-16 ${tone === "slate" ? "bg-slate-50" : "bg-white"}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className={flip ? "lg:order-2" : undefined}>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{title}</h2>
            <p className="mt-4 max-w-xl text-lg text-gray-600">{description}</p>
          </div>
          <div className={`w-full max-w-md ${flip ? "lg:order-1 lg:justify-self-end" : ""}`}>{children}</div>
        </div>
      </div>
    </section>
  );
}
